import React from 'react';
import { Table, Button } from 'antd';
import { useEffect } from 'react';

const TableSPStockSupplier = ({ data, loading, page, pageSize, showModalDetail, showModalDetailAdjust, isMobile, setPage, setPagesize, setMainSort }) => {
  const columns = [
    {
      title: 'Before Item',
      dataIndex: 'before_item',
      sorter: true,
    },
    {
      title: 'Supplier',
      dataIndex: 'supplier',
      sorter: true,
    },
    {
      title: 'Std Qty',
      dataIndex: 'std_qty',
      sorter: true,
    },
    {
      title: 'Qty In',
      dataIndex: 'qty_in',
      sorter: true,
    },
    {
      title: 'Qty Out',
      dataIndex: 'qty_out',
      sorter: true,
    },
    {
      title: 'Current Stock',
      dataIndex: 'current_stock',
      sorter: true,
      render: (text, record) => (
        <Button type="link" onClick={() => showModalDetail(record)}>
          {text}
        </Button>
      ),
    },
    {
      title: 'Total Adjust',
      dataIndex: 'total_adjust',
      sorter: true,
      render: (text, record) => {
        const formatted = record.total_adjust > 0 ? `+${record.total_adjust}` : record.total_adjust;

        return (
          <Button type="link" onClick={() => showModalDetailAdjust(record)}>
            {formatted}
          </Button>
        );
      },
    },
    {
      title: 'Actual Stock',
      dataIndex: 'actual_stock',
      sorter: true,
    },
    {
      title: 'Unit',
      dataIndex: 'unit',
      sorter: true,
    },
    {
      title: 'Last Update',
      dataIndex: 'last_update',
      sorter: true,
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setPagesize(pagination.pageSize);

    const sortField = sorter.field;
    const sortOrder = sorter.order;

    if (sortField && sortOrder) {
      setMainSort({
        sort: sortField,
        order: sortOrder,
      });
    } else {
      setMainSort({
        sort: 'created_at',
        order: 'descend',
      });
    }
  };

  return (
    <Table
      columns={columns}
      dataSource={data?.data || []}
      loading={loading}
      pagination={{
        current: page,
        pageSize: pageSize,
        total: data?.total || 0,
        showSizeChanger: true,
      }}
      onChange={handleTableChange}
      rowKey={(record, index) => record.before_item || index}
      // scroll={isMobile ? { x: 'max-content' } : undefined}
      scroll={{ x: 'max-content' }}
    />
  );
};

export default TableSPStockSupplier;
